import React from 'react';

interface Props {
    publicationDates;
    kinds;
    data;
}

const HtmlDocumentLayout = (props: Props) => {

    let host = window.location.origin;
    let prefix = window.location.pathname.split("/").filter(n=> n)[0];
    let baseURL = host + '/' + prefix

    const { data, kinds, publicationDates } = props;

    const kindCodes = kinds.join(' or ');

    const bodyStyles = {
        width: '800px',
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: '15px',
    };

    const tableStyles = {
        width: '800px',
        borderSpacing: '0px',
    };

    const linkStyles = {
        textDecoration: 'none',
        color: '#0b2a43',
    };

    const trStyles = {
        height: '30px',
        borderBottom: '1px solid grey',
    };

    return (
        <html>
            <head>
                <meta charSet="UTF-8" />
                <title>Result List</title>
            </head>
            <body style={bodyStyles}>
                <h2 style={{ color: '#be0f05' }}>Result list</h2>
                <div style={{ maxWidth: '250px' }}>
                    <div>
                        Publication Date <strong>[{publicationDates}]</strong>
                    </div>
                    <div>
                        Kind Code = <strong>{kindCodes}</strong>
                    </div>
                </div>
                <p>
                    The publication of patent documents by way of this site is subject to a{' '}
                    <a href="#disclaimer">disclaimer</a>
                    <sup>1</sup> in respect of the accuracy of replication.
                </p>
                <table style={tableStyles}>
                    <thead style={{ backgroundColor: '#C9CBCE', textAlign: 'left' }}>
                        <th>
                            <h4>
                                Publication number<sup>1</sup>
                            </h4>
                        </th>
                        <th>
                            <h4>Kind code</h4>
                        </th>
                        <th>
                            <h4>Publication date</h4>
                        </th>

                        <th>
                            <h4>
                                XML<sup>1</sup>
                            </h4>
                        </th>

                        <th>
                            <h4>PDF/PCT</h4>
                        </th>
                        <th>
                            <h4>
                                ZIP<sup>1</sup>
                            </h4>
                        </th>
                        <th>
                            <h4>&nbsp;</h4>
                        </th>

                        <th>
                            <h4>&nbsp;</h4>
                        </th>
                    </thead>
                    <tbody>
                        {data.map((item) => {
                            return (
                                <tr key={item.publicationNumber} style={trStyles}>
                                    <td>{item.publicationNumber}</td>
                                    <td>{item.publicationKind}</td>
                                    <td>{item.publicationDate}</td>
                                    <td>
                                        <a style={linkStyles} href={`${baseURL}/document/xml/${item.publicationNumber}/${item.publicationKind}/${item.publicationDate}`}>
                                            <strong>XML</strong>
                                        </a>
                                    </td>
                                    <td>
                                        <a style={linkStyles} href={`${baseURL}/document/pdf/${item.publicationNumber}/${item.publicationKind}/${item.publicationDate}`}>
                                            <strong>PDF</strong>
                                        </a>
                                    </td>
                                    <td id="zip">
                                    <a style={linkStyles} href={`${baseURL}/document/zip?path=${item.zipFile}`}>
                                            <strong>ZIP</strong>
                                        </a>
                                    </td>
                                    <td>
                                        <a style={linkStyles} href={item.espacenetLink}>
                                            <strong>Espacenet</strong>
                                        </a>
                                    </td>
                                    <td>
                                        <a style={linkStyles} href={item.registerLink}>
                                            <strong>Register</strong>
                                        </a>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div>
                    <br />
                    <p id="disclaimer">
                        <sup>1</sup> XML data for documents published prior to 1 January 2006 has been converted using a
                        procedure that may result in accidental changes. It therefore cannot be guaranteed that XML data
                        as rendered in HTML or made available in the ZIP file accurately replicates the respective
                        original documents.
                    </p>
                    <p>
                        For documents published prior to 1 January 2006, only the PDF versions (in the ZIP file) are
                        accurate replications or - in accordance with{' '}
                        <a
                            href="https://archive.epo.org/epo/pubs/oj007/08_07/special_edition_3_epc_2000_decisions.pdf"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Decision of President of the European Patent Office dated 12 July 2007
                        </a>{' '}
                        concerning the form of publication of European patent applications, European search reports and
                        European patent specifications (Special edition No. 3, OJ EPO 2007, D3) - electronic
                        publications of the respective original documents, as the case may be. The HTML view is in all
                        cases for users' convenience only. It cannot be guaranteed that this view accurately reflects
                        the underlying XML data.
                    </p>
                </div>
            </body>
        </html>
    );
};

export default HtmlDocumentLayout;
